<template>


    <header
      style='background: url("assets/img/header%20geometric%20background%20image.jpg") center / cover;'
    >
      <div class="row">
        <div class="col">
          <div
            class="container d-flex d-xxl-flex justify-content-start justify-content-xxl-start"
            style="text-align: center;font-family: 'Hammersmith One', sans-serif;padding-bottom: 33px;"
          >
            <a href="https://feeless.finance" target="_blank"
              ><img
                class="img-fluid"
                src="assets/img/FeeLess%20Logo.png"
                width="150px"
            /></a>
          </div>
        </div>
      </div>
    </header>
    <div class="container">
      <div class="row d-flex justify-content-center" id="row-header">
        <div
          class="col d-flex d-xxl-flex align-items-center align-items-sm-center align-items-xxl-center"
          id="col-header-1"
          style="margin-bottom: 30px;"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="1em"
            height="1em"
            viewBox="0 0 24 24"
            stroke-width="2"
            stroke="currentColor"
            fill="none"
            stroke-linecap="round"
            stroke-linejoin="round"
            class="icon icon-tabler icon-tabler-transfer"
            style="color: var(--bs-body-bg);margin-right: 8px;font-size: 20px;"
          >
            <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
            <path d="M20 10h-16l5.5 -6"></path>
            <path d="M4 14h16l-5.5 6"></path>
          </svg>
          <h2 id="h-tkn-transf">
            <strong
              ><span
                style="color: var(--bs-body-bg); background-color: rgb(51, 39, 70);"
                >TOKEN TRANSFER</span
              ></strong
            >
          </h2>
        </div>
        <div
          class="col d-sm-flex d-xxl-flex justify-content-sm-end justify-content-xxl-end align-items-xxl-center"
          id="col-header-2"
          style="margin-bottom: 30px;"
        >

          <form>
            <div v-if="!isValidNetwork && isLoggedIn">
              <router-link type="button" class="btn btn-primary d-flex justify-content-center align-items-center" :to="{ name: 'Logout'}" ><p>Disconnect</p>
                <svg
              xmlns="http://www.w3.org/2000/svg"
              width="1em"
              height="1em"
              viewBox="0 0 24 24"
              stroke-width="2"
              stroke="currentColor"
              fill="none"
              stroke-linecap="round"
              stroke-linejoin="round"
              class="icon icon-tabler icon-tabler-plug-connected"
              id="icon-connect"
            >
              <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
              <path
                d="M7 12l5 5l-1.5 1.5a3.536 3.536 0 1 1 -5 -5l1.5 -1.5z"
              ></path>
              <path
                d="M17 12l-5 -5l1.5 -1.5a3.536 3.536 0 1 1 5 5l-1.5 1.5z"
              ></path>
              <path d="M3 21l2.5 -2.5"></path>
              <path d="M18.5 5.5l2.5 -2.5"></path>
              <path d="M10 11l-2 2"></path>
              <path d="M13 14l-2 2"></path>
            </svg>
              </router-link>
              
            </div>
            <div v-else>
              <div v-if="isLoggedIn">
                <div class="btn-group" role="group" aria-label="Basic example">
                  <a type="button" class="btn btn-primary" alt="{{homeProvider.account}}">{{shortAccount}}</a>
                  <a type="button" class="btn btn-primary">{{homeProvider.networkName}}</a>
                  <router-link type="button" class="btn btn-primary d-flex justify-content-center align-items-center" :to="{ name: 'Logout'}" >Disconnect
                <svg
              xmlns="http://www.w3.org/2000/svg"
              width="1em"
              height="1em"
              viewBox="0 0 24 24"
              stroke-width="2"
              stroke="currentColor"
              fill="none"
              stroke-linecap="round"
              stroke-linejoin="round"
              class="icon icon-tabler icon-tabler-plug-connected"
              id="icon-connect"
            >
              <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
              <path
                d="M7 12l5 5l-1.5 1.5a3.536 3.536 0 1 1 -5 -5l1.5 -1.5z"
              ></path>
              <path
                d="M17 12l-5 -5l1.5 -1.5a3.536 3.536 0 1 1 5 5l-1.5 1.5z"
              ></path>
              <path d="M3 21l2.5 -2.5"></path>
              <path d="M18.5 5.5l2.5 -2.5"></path>
              <path d="M10 11l-2 2"></path>
              <path d="M13 14l-2 2"></path>
            </svg>
              </router-link>
                </div>
              </div>
              <div v-else>
                <router-link type="button" id="btn-conct-metamask" data-bss-hover-animate="pulse" class="btn btn-primary d-flex justify-content-center align-items-center" :to="{ name: 'Login'}" >Connect metamask
                  <svg
              xmlns="http://www.w3.org/2000/svg"
              width="1em"
              height="1em"
              viewBox="0 0 24 24"
              stroke-width="2"
              stroke="currentColor"
              fill="none"
              stroke-linecap="round"
              stroke-linejoin="round"
              class="icon icon-tabler icon-tabler-plug-connected"
              id="icon-connect"
            >
              <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
              <path
                d="M7 12l5 5l-1.5 1.5a3.536 3.536 0 1 1 -5 -5l1.5 -1.5z"
              ></path>
              <path
                d="M17 12l-5 -5l1.5 -1.5a3.536 3.536 0 1 1 5 5l-1.5 1.5z"
              ></path>
              <path d="M3 21l2.5 -2.5"></path>
              <path d="M18.5 5.5l2.5 -2.5"></path>
              <path d="M10 11l-2 2"></path>
              <path d="M13 14l-2 2"></path>
            </svg>
                </router-link>
              </div>
            </div>
          </form>
        </div>
      </div>

      
    <router-view>

    </router-view>

    </div>
    <footer class="text-center" id="footer">
      <div class="container text-white py-4 py-lg-5">
        <ul class="list-inline" style="font-size: 12px;">
          <li class="list-inline-item me-4">
            <a class="link-light" href="https://feeless.finance" target="_blank"
              >Home</a
            >
          </li>
          <li class="list-inline-item me-4">
            <a class="link-light" href="https://feeless.finance/terms/">Terms of Use</a>
          </li>
          <li class="list-inline-item me-4">
            <a class="link-light" href="https://feeless.finance/privacy-policy/">Privacy Policy</a>
          </li>
          <li class="list-inline-item">
            <a class="link-light" href="https://feeless.finance/cookie-policy/">Cookie Policy</a>
          </li>
        </ul>
        <ul class="list-inline">
          <li class="list-inline-item me-4">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="1em"
              height="1em"
              fill="currentColor"
              viewBox="0 0 16 16"
              class="bi bi-facebook text-light"
            >
              <path
                d="M16 8.049c0-4.446-3.582-8.05-8-8.05C3.58 0-.002 3.603-.002 8.05c0 4.017 2.926 7.347 6.75 7.951v-5.625h-2.03V8.05H6.75V6.275c0-2.017 1.195-3.131 3.022-3.131.876 0 1.791.157 1.791.157v1.98h-1.009c-.993 0-1.303.621-1.303 1.258v1.51h2.218l-.354 2.326H9.25V16c3.824-.604 6.75-3.934 6.75-7.951"
              ></path>
            </svg>
          </li>
          <li class="list-inline-item me-4">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="1em"
              height="1em"
              fill="currentColor"
              viewBox="0 0 16 16"
              class="bi bi-twitter text-light"
            >
              <path
                d="M5.026 15c6.038 0 9.341-5.003 9.341-9.334 0-.14 0-.282-.006-.422A6.685 6.685 0 0 0 16 3.542a6.658 6.658 0 0 1-1.889.518 3.301 3.301 0 0 0 1.447-1.817 6.533 6.533 0 0 1-2.087.793A3.286 3.286 0 0 0 7.875 6.03a9.325 9.325 0 0 1-6.767-3.429 3.289 3.289 0 0 0 1.018 4.382A3.323 3.323 0 0 1 .64 6.575v.045a3.288 3.288 0 0 0 2.632 3.218 3.203 3.203 0 0 1-.865.115 3.23 3.23 0 0 1-.614-.057 3.283 3.283 0 0 0 3.067 2.277A6.588 6.588 0 0 1 .78 13.58a6.32 6.32 0 0 1-.78-.045A9.344 9.344 0 0 0 5.026 15"
              ></path>
            </svg>
          </li>
          <li class="list-inline-item">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="1em"
              height="1em"
              fill="currentColor"
              viewBox="0 0 16 16"
              class="bi bi-instagram text-light"
            >
              <path
                d="M8 0C5.829 0 5.556.01 4.703.048 3.85.088 3.269.222 2.76.42a3.917 3.917 0 0 0-1.417.923A3.927 3.927 0 0 0 .42 2.76C.222 3.268.087 3.85.048 4.7.01 5.555 0 5.827 0 8.001c0 2.172.01 2.444.048 3.297.04.852.174 1.433.372 1.942.205.526.478.972.923 1.417.444.445.89.719 1.416.923.51.198 1.09.333 1.942.372C5.555 15.99 5.827 16 8 16s2.444-.01 3.298-.048c.851-.04 1.434-.174 1.943-.372a3.916 3.916 0 0 0 1.416-.923c.445-.445.718-.891.923-1.417.197-.509.332-1.09.372-1.942C15.99 10.445 16 10.173 16 8s-.01-2.445-.048-3.299c-.04-.851-.175-1.433-.372-1.941a3.926 3.926 0 0 0-.923-1.417A3.911 3.911 0 0 0 13.24.42c-.51-.198-1.092-.333-1.943-.372C10.443.01 10.172 0 7.998 0h.003zm-.717 1.442h.718c2.136 0 2.389.007 3.232.046.78.035 1.204.166 1.486.275.373.145.64.319.92.599.28.28.453.546.598.92.11.281.24.705.275 1.485.039.843.047 1.096.047 3.231s-.008 2.389-.047 3.232c-.035.78-.166 1.203-.275 1.485a2.47 2.47 0 0 1-.599.919c-.28.28-.546.453-.92.598-.28.11-.704.24-1.485.276-.843.038-1.096.047-3.232.047s-2.39-.009-3.233-.047c-.78-.036-1.203-.166-1.485-.276a2.478 2.478 0 0 1-.92-.598 2.48 2.48 0 0 1-.6-.92c-.109-.281-.24-.705-.275-1.485-.038-.843-.046-1.096-.046-3.233 0-2.136.008-2.388.046-3.231.036-.78.166-1.204.276-1.486.145-.373.319-.64.599-.92.28-.28.546-.453.92-.598.282-.11.705-.24 1.485-.276.738-.034 1.024-.044 2.515-.045v.002zm4.988 1.328a.96.96 0 1 0 0 1.92.96.96 0 0 0 0-1.92zm-4.27 1.122a4.109 4.109 0 1 0 0 8.217 4.109 4.109 0 0 0 0-8.217zm0 1.441a2.667 2.667 0 1 1 0 5.334 2.667 2.667 0 0 1 0-5.334"
              ></path>
            </svg>
          </li>
        </ul>
        <p class="text-muted mb-0">Copyright © 2024 Brand</p>
      </div>
    </footer>
   
    
</template>

<script>
import { defineComponent } from 'vue';
import { useHead } from '@vueuse/head';
export default defineComponent({
  name: 'App',
    computed: {
      homeProvider() {
        return this.$store.state.homeProvider;
      },
      chainId() {
        return this.$store.state.homeProvider.chainID;
      },
      isValidNetwork: function () {
        if(this.chainId == 1075  ){
          return true;
        
        }
      },
      isLoggedIn: function () {
        if(Object.keys(this.homeProvider).length == 0){
          return false;
        }else {
          return true;
        }
      },
      shortAccount: function () {
        if(Object.keys(this.homeProvider).length == 0){
          return "Not connected";

        }else {
          return  this.homeProvider.account.substring(0,6)+"..."+this.homeProvider.account.substring(this.homeProvider.account.length - 3);

        }
      }
    },
    setup() {
      /*
    useHead({
      title: 'FeeLess Token Faucet - Transfer to Your Wallet',
      meta: [
        { charset: 'utf-8' },
        { name: 'viewport', content: 'width=device-width, initial-scale=1.0, shrink-to-fit=no' },
        { rel: 'canonical', href: 'https://faucet.feeless.finance/' },
        { property: 'og:url', content: 'https://faucet.feeless.finance/' },
        { name: 'twitter:description', content: 'Select the token and transfer it to your Metamask address.in one click.' },
        { name: 'twitter:card', content: 'summary_large_image' },
        { property: 'og:type', content: 'website' },
        { name: 'description', content: 'Select the token and transfer it to your Metamask address.in one click.' },
        { property: 'og:image', content: 'https://faucet.feeless.finance/assets/img/FeeLess Mission.jpg' },
        { name: 'twitter:image', content: 'https://faucet.feeless.finance/assets/img/FeeLess Mission.jpg' },
        { name: 'twitter:title', content: 'FeeLess Token Faucet - Transfer to Your Wallet' }
      ],
      link: [
        { rel: 'icon', type: 'image/png', sizes: '61x61', href: 'assets/img/FeeLess Favicon.png' },
        { rel: 'stylesheet', href: 'assets/bootstrap/css/bootstrap.min.css' },
        { rel: 'stylesheet', href: 'assets/css/styles.min.css' }
      ],
      script: [
        {
          type: 'application/ld+json',
          json: {
            "@context": "http://schema.org",
            "@type": "WebSite",
            "name": "FeeLess Finance",
            "url": "https://faucet.feeless.finance"
          }
        },
        {
          src: 'assets/bootstrap/js/bootstrap.min.js',
          async: true // Se lo script può essere caricato asincronamente, aggiungi async: true
        },
        {
          src: 'assets/js/script.min.js',
          defer: true // Se lo script deve essere eseguito dopo che il documento è stato completamente caricato, usa defer: true
        }
      ]
    })*/
    return {};
  }
});
</script>